"use strict";

module.exports = function () {
	require("component/core/core.js");
require("component/analysis/analysis.custom.js");







require("component/search-form/placeholder/placeholder.js");
require("component/search-form/compact/compact.js");
require("component/search-form/extendable/extendable.custom.js");
require("component/search-form/label/label.js");


require("component/menu/horizontal-multilevel-2/horizontal-multilevel-2.js");
require("component/menu/horizontal-multilevel-3/horizontal-multilevel-3.js");
require("component/menu/horizontal-multilevel-4/horizontal-multilevel-4.js");
require("component/menu/vertical-multilevel-2/vertical-multilevel-2.js");


require("component/my-report/my-report.custom.js");
require("component/forms/forms.custom.js");

require("component/materials/static-in-column/static-in-column.js");
require("component/materials/compact-in-column/compact-in-column.js");
require("component/materials/compact-vertical-icons/compact-vertical-icons.js");
require("component/map/map.js");
require("component/tools-panel/tools-panel.js");
require("component/tools-panel/static-in-column/static-in-column.js");
require("component/tools-panel/compact-in-column/compact-in-column.js");
require("component/tools-panel/static-in-line/static-in-line.js");
require("component/tools-panel/compact-in-line/compact-in-line.js");
require("component/tools-panel/compact-vertical-icons/compact-vertical-icons.js");


require("component/social-services/compact/compact.js");

require("component/tour/tour.js");






require("component/error-report/error-report.js");
require("component/mistake-correction/mistake-correction.js");
require("component/tables/tables.js");
require("component/tabs-accordions/tabs-accordions.custom.js");

require("component/svg/svg.js");
require("component/zoom-in/zoom-in.js");
require("component/excel-export/excel-export.js");
require("component/graphic/graphic.js");
require("component/charts/charts.js");
require("component/tooltips/tooltips.js");



require("component/seemore/compact/compact.js");
require("component/locale/locale.js");
require("component/personal/personal.js");
require("component/page-nav/page-nav.js");


require("component/main-page/main-page.js");
require("component/business-model/business-model.js");
;
};

module.exports = module.exports.apply(module, [])


/*****************
 ** WEBPACK FOOTER
 ** ./~/apply-loader!./~/callback-loader/callback-loader.js!./frontend/components.js
 ** module id = 2
 ** module chunks = 0
 **/